module.exports = __webpack_public_path__ + "static/media/add stock usage.f9618c9b.svg";